<div class="container">
    <h1 class="page-title"><span class="icon"><i class="fas fa-pallet"></i></span>角色權限對應表</h1>
    <p-card>
        <form>
            <div class="p-fluid formgrid grid">
                <div class="field col-6">
                    <label class="title">UserType</label>
                    <!-- <p-dropdown [options]="userTypeOptions" [(ngModel)]="userTypeSelected" (onChange)="userTypeChange($event)" [ngModelOptions]="{standalone: true}"></p-dropdown> -->
                    <div>
                        {{userTypeSelected}}
                    </div>
                </div>
                <div class="field col-6">
                    <label class="title">Role</label>
                    <div>
                        {{roleSelected | optionsMapping:roleOptions}}
                    </div>
                    <!-- <p-dropdown [options]="roleOptions" [(ngModel)]="roleSelected" (onChange)="roleChange($event)" [ngModelOptions]="{standalone: true}"></p-dropdown> -->
                </div>
            </div>
            <div class="mt-3">
                <p-pickList #pl [source]="tempPermissions" [target]="selectedPermission" [dragdrop]="true" [responsive]="true" filterBy="permissionCode,permissionName">
                    <ng-template let-permission pTemplate="item">
                        <div>
                            <div style="font-size:14px;margin:15px 5px 0 0">{{permission.permissionCode}} - {{permission.permissionName}}</div>
                        </div>
                    </ng-template>
                </p-pickList>
            </div>
            <div class="grid mt-5">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="modifyBtn($event)"></button>
                    <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="cancelBtnClick($event)" class="p-button-secondary ml-5"></button>
                </div>
            </div>
        </form>
    </p-card>
</div>
